<template>
  <div class="tour-container">
    <iframe width="100%" height="100%" style="width: 100%; height: 100%; border: none; max-width: 100%;"
      frameborder="0" allow="vr,gyroscope,accelerometer,fullscreen" scrolling="no" allowfullscreen="true"
      :src="link">
    </iframe>
  </div>
</template>

<script>
export default {
  name: 'TourFrame',
  props: {
    link: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.tour-container{
  position: relative;
  width: 100%;
  height: calc(100% - 64px);
}

@media only screen and (max-width: 960px) {
  .tour-container {
    height: calc(100% - 48px);
  }
}

@media only screen and (max-width: 599px) {
  .tour-container {
    height: calc(100% - 56px);
  }
}

</style>
